// web/src/tutorial/detail/index.ts
// 「软件界面详细说明」文档注册表。顺序 = 页尾「上一个 / 下一个产品」的顺序，
// 与产品矩阵、Quick Start 保持一致。

import type { TutorialDoc } from "../types";
import { beatBloomDetail } from "./beat-bloom";
import { fretDanceDetail } from "./fret-dance";
import { harpGlideDetail } from "./harp-glide";
import { keyRippleDetail } from "./key-ripple";
import { stringFlowDetail } from "./string-flow";
import { windRiseDetail } from "./wind-rise";
import { zhengDriftDetail } from "./zheng-drift";

export const DETAIL_DOCS: TutorialDoc[] = [
  keyRippleDetail,
  stringFlowDetail,
  fretDanceDetail,
  beatBloomDetail,
  zhengDriftDetail,
  harpGlideDetail,
  windRiseDetail,
];
